import { Ticket } from '@product/const';
import { PROCESS_FEATURE, StateUtils } from '@spartacus/core';
import { TICKET_PROCESS_ID } from '../product-state';

export const TICKET_REQUEST = '[Ticket] Ticket Request';
export const TICKET_REQUEST_SUCCESS = '[Ticket] Ticket Request Success';
export const TICKET_REQUEST_FAIL = '[Ticket] Ticket Request Fail';
export const TICKET_REQUEST_RESET = '[Ticket] Ticket Request Reset';

export class TicketRequest extends StateUtils.EntityLoadAction {
  readonly type = TICKET_REQUEST;

  constructor(public payload: Ticket) {
    super(PROCESS_FEATURE, TICKET_PROCESS_ID);
  }
}

export class TicketRequestFail extends StateUtils.EntityFailAction {
  readonly type = TICKET_REQUEST_FAIL;

  constructor(public payload: any) {
    super(PROCESS_FEATURE, TICKET_PROCESS_ID, payload);
  }
}

export class TicketRequestSuccess extends StateUtils.EntitySuccessAction {
  readonly type = TICKET_REQUEST_SUCCESS;

  constructor() {
    super(PROCESS_FEATURE, TICKET_PROCESS_ID);
  }
}

export class TicketRequestReset extends StateUtils.LoaderResetAction {
  readonly type = TICKET_REQUEST_RESET;

  constructor() {
    super(PROCESS_FEATURE);
  }
}

export type TicketRequestAction = TicketRequest | TicketRequestFail | TicketRequestSuccess | TicketRequestReset;
